module.exports = __webpack_public_path__ + "img/tarot-major-arcana-15.92aca83c.png";